// Module
var code = `<div> <ul> <li ng-if="data[field] !== null" ng-repeat="val in data[field]"> <span class="text-primary">[{{ val }}]</span> <recursive-directive ng-if="data[val] !== null" data="data" field="val"></recursive-directive> </li> </ul> </div>`;
// Exports
module.exports = code;